import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  HostListener,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { DOCUMENT } from '@angular/common';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { environment } from '../../../environments/environment';

import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { FlightService } from 'src/app/core/services/flight.service';
import { DataShareService } from 'src/app/core/services/datashare.sevice';
import { OrganizationSettingsService } from 'src/app/core/services/organization-settings.service';
import { PulseStaffService } from 'src/app/core/services/pulse-staff.service';
import { PulseWidgetService } from 'src/app/core/services/pulse-widget.service';
import { PulseMyTicketsService } from 'src/app/core/services/pulse-my-tickets.service';
import { Subscription } from 'rxjs';

/** A page in the Manage panel. */
interface HubLink {
  label: string;
  link: string;
  icon?: string;
  path?: string;
}

/** A second-level item: a page, or a group of pages (e.g. Payments, Supplier). */
interface HubEntry {
  label: string;
  icon?: string;
  link?: string;
  children: HubLink[];
}

/** One tab of the Manage panel (Accounts, Operations, ...). */
interface HubSection {
  label: string;
  icon?: string;
  subtitle: string;
  count: number;
  entries: HubEntry[];
  links: HubLink[];
}

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss'],
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
  public logoUrl: string;
  public imageUrl = environment?.imageUrl;
  public logoHeight = environment?.logoHeight;
  public logoFailed = false;
  public client = environment?.clientAbbr;
  userRole: string;
  authArr = ['super_admin', 'admin', 'finance', 'sales', 'operations'];
  isProxy: boolean = false;
  public userName: string;
  public mobileIconView: boolean = false;
  public profileIcon: boolean = false;
  public activeButton;
  public index = null;
  public totalAmount;
  element;
  configData;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  permissions = [];
  menuItems = [];
  showRechargeButton: boolean = false;
  public avalBal;
  public overDraft;
  public subIndex = null;
  public billingCode = '';

  isLoadingBal = false;

  listLang = [
  ];

  // imageUrl + logoUrl is the CDN copy; when it 404s (or the CDN is down) fall
  // back to logoUrl on its own. Guarded so a failing fallback can't re-enter.
  onLogoError() {
    if (!this.logoFailed) this.logoFailed = true;
  }

  @ViewChild('dropdown') dropdown: ElementRef;
  @ViewChild('subMenu') subMenu: ElementRef;
  @ViewChild('topnav-menu-content') sideMenu: ElementRef;

  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private authService: AuthenticationService,
    private storageService: StorageService,
    private tostrService: ToastService,
    private flightService: FlightService,
    private eventService: EventService,
    private elementRef: ElementRef,
    private dateShareService: DataShareService,
    private organizationSettingsService: OrganizationSettingsService,
    private pulseStaff: PulseStaffService,
    private pulseWidget: PulseWidgetService,
    private pulseMyTickets: PulseMyTicketsService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selectedTab(event.urlAfterRedirects);
        this.activateMenu();
        this.closeAllMenus();
      }
    });
  }

  /**
   * Close open menus when the user presses anywhere outside the menu bar.
   * Listens in the capture phase: many page components stop click propagation
   * (e.g. the search form's own pop-ups), so a bubbling document click never
   * arrived and the dropdown stayed open.
   */
  private outsidePointerListener = (event: PointerEvent) => {
    const nav = this.elRef.nativeElement.querySelector('.inner-nav') as HTMLElement | null;
    const target = event.target as Node | null;
    // the Welcome (profile) dropdown closes on a press anywhere outside it
    const profile = this.elRef.nativeElement.querySelector('.prof-link') as HTMLElement | null;
    if (this.profileIcon && target && !profile?.contains(target)) {
      this.profileIcon = false;
    }
    if (!nav || !target || nav.contains(target)) return;
    if (this.index !== null || this.subIndex !== null || this.manageOpen) {
      this.closeAllMenus();
    }
  };

  closeAllMenus() {
    this.index = null;
    this.subIndex = null;
    this.manageOpen = false;
  }

  ngOnDestroy(): void {
    document.removeEventListener('pointerdown', this.outsidePointerListener, true);
    this.supportSubs.forEach((sub) => sub.unsubscribe());
  }

  /** eth staff with ETH Pulse access see a "Pulse" link that signs them in. */
  pulseAccess = false;

  openPulse(): void {
    this.pulseStaff.openPulse().catch((err) => {
      this.tostrService.error(err?.error?.message || 'Could not open Pulse', 'Ok');
    });
  }

  /** Users with the support chat see "Support", with how many conversations wait on their reply. */
  supportLink = false;
  supportNeedsReply = 0;
  private supportSubs: Subscription[] = [];

  private watchSupport(): void {
    this.supportSubs.push(
      this.pulseWidget.active$.subscribe((active) => (this.supportLink = active)),
      this.pulseMyTickets.watchNeedsReply(),
      this.pulseMyTickets.needsReply$.subscribe((count) => (this.supportNeedsReply = count)),
    );
  }

  @HostListener('document:click') onClick(): void {
    // onClickOutside(event?: Event) {
    // Check if the click was outside the component
    // Direct DOM query to find the next sibling element
    const dropdownElement = document.querySelectorAll('.dropdown');

    // Check if the click was outside the component
    // Direct DOM query to find the next sibling element

    if (dropdownElement) {
      dropdownElement.forEach((dropdown, i) => {
        if (dropdown) {
          const nextEl = dropdown.classList;
          if (nextEl) {
            // Check if the next element has the class 'show' and remove it

            if (dropdown.classList.contains('show')) {
              this.index = null;
              this.subIndex = null;
            }
          }
        }
      });
    }
  }

  private inactivityTimer: any;

  startInactivityTimer(): void {
    const dropdownElement = document.querySelectorAll('.dropdown');

    clearTimeout(this.inactivityTimer); // Reset timer
    this.inactivityTimer = setTimeout(() => {
      if (dropdownElement) {
        dropdownElement.forEach((dropdown, i) => {
          if (dropdown) {
            const nextEl = dropdown.classList;
            if (nextEl) {
              // Check if the next element has the class 'show' and remove it

              if (dropdown.classList.contains('show')) {
                this.index = null;
              }
            }
          }
        });
      }
    }, 5000); // 5 seconds of inactivity
  }
  ngOnInit(): void {
    // capture phase, so it runs even when a page component stops propagation
    document.addEventListener('pointerdown', this.outsidePointerListener, true);
    this.getProxyStatus();
    this.subscribeThemeDataSubj();
    // Pulse link (eth staff) and the support "needs your reply" count.
    this.pulseStaff.hasAccess().subscribe((allowed) => (this.pulseAccess = allowed));
    this.watchSupport();

    this.permissions = JSON.parse(
      JSON.stringify(this.storageService.getLocalStorageItem('permissions'))
    );
    this.element = document.documentElement;
    this.billingCode = this.storageService.getLocalStorageItem('BillingCode');

    this.initialize();

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = this.imageUrl + 'assets/images/flags/us.jpg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    this.userName = this.storageService.getLocalStorageItem('user_name');
    this.getAccountAmount();
    this.dateShareService.creaditDetails$.subscribe({
      next: (res: any) => {
        this.totalAmount = res;
        this.avalBal = (
          Number(res?.F) +
          Number(res?.L) +
          Number(res.V) +
          Number(res?.I) +
          Number(res?.O) +
          Number(res?.H) -
          Number(res?.hold_amount)
        ).toFixed(2);
        this.overDraft = (
          Number(res?.LC) +
          Number(res?.FC) +
          Number(res.VC) +
          Number(res?.IC) +
          Number(res?.OC) +
          Number(res?.HC)
        ).toFixed(2);
        if (this.totalAmount)
          this.dateShareService.setCreaditValue(
            JSON.parse(JSON.stringify(this.totalAmount))
          );
      },
    });
    this.checkRecharge();
    this.selectedTab();
  }

  subscribeThemeDataSubj() {
    this.organizationSettingsService.themeSubject$.subscribe((res) => {
      const themeData = this.storageService.getLocalStorageItem('themeData');
      this.logoUrl = themeData?.selected_image || environment?.logoUrl;
      // Unlike the header/footer, logoUrl arrives asynchronously, so the img
      // can 404 on `imageUrl + undefined` before the theme lands. Clear the
      // flag for each new logo so that early miss doesn't pin the fallback.
      this.logoFailed = false;
    });
  }

  selectedTab(url: string = this.router.url) {
    this.activeButton = this.menuLabelForUrl(url);
  }

  /**
   * Top-level menu a URL belongs to: the item owning the longest menu link that matches
   * the path (e.g. '/admin/confirmed-bookings' -> Flight), otherwise the module the path
   * starts with, for pages outside the menu ('/flight-booking', '/bus-failed-bookings').
   */
  private menuLabelForUrl(url: string): string | undefined {
    const path = url.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
    let best: { label: string, length: number } | undefined;
    const visit = (label: string, item: any) => {
      const link = item?.link?.replace(/\/+$/, '');
      if (link && link !== '/' && (path === link || path.startsWith(link + '/')) && link.length > (best?.length ?? 0)) {
        best = { label, length: link.length };
      }
      item?.subItems?.forEach((sub: any) => visit(label, sub));
    };
    MENU.forEach((item: any) => visit(item.label, item));
    if (best) return best.label;

    // Main-menu labels map to URL prefixes: 'Control Panel' -> 'control-panel', and
    // 'Holidays' also owns 'holiday-list' / 'holiday-details'.
    const segment = path.split('/')[1] || '';
    return MENU.find((item: any) => {
      const slug = item?.label.toLowerCase().replace(/\s+/g, '-');
      return [slug, slug.replace(/s$/, '')].some((s) => segment === s || segment.startsWith(s + '-'));
    })?.label;
  }

  checkRecharge() {
    this.flightService.checkRecharge().subscribe({
      next: (res: any) => {
        this.showRechargeButton = res?.data?.show_button;
        this.storageService.setLocalStorageItem('BillingCode', res?.data?.billing_code);
      },
    });
  }


  getAccountAmount() {
    this.isLoadingBal = true;
    this.flightService.getAccountBalance().subscribe((response) => {
      this.isLoadingBal = false;
      this.totalAmount = JSON.parse(JSON.stringify(response));
      this.dateShareService.setCreaditValue(this.totalAmount);
    },
      () => {
        this.isLoadingBal = false;
      });
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.storageService.removeLocalStorageValue('proxyToken');
    this.tostrService.success('Logout successfully', '');
    this.router.navigate(['/']);
    this.dateShareService.setBorderData(false);
  }

  /**
   * On menu click
   */
  onMenuClick(event: any, index?, activeButton?) {
    event.stopPropagation();
    this.index = index;
    const nextEl = event.target.nextElementSibling;
    if (activeButton?.label.toLowerCase() === 'flight')
      this.router.navigateByUrl('/flight/flight-search');
    if (activeButton?.label.toLowerCase() === 'hotel')
      this.router.navigateByUrl('/hotel');

    if (activeButton) this.activeButton = activeButton.label;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
      }
    }
    return false;
  }
  // ---- split product items (desktop): label opens the product, arrow the menu ----
  private readonly productLanding: Record<string, string> = {
    flight: '/flight/flight-search',
    hotel: '/hotel',
  };

  /** Where a product's label goes: its own link, a known landing page, or its first page. */
  landingLink(item: any): string | null {
    if (item?.link) return item.link;
    const known = this.productLanding[(item?.label || '').toLowerCase()];
    if (known) return known;
    const first = (items: any[]): string | null => {
      for (const it of items || []) {
        if (it?.link) return it.link;
        const nested = first(it?.subItems);
        if (nested) return nested;
      }
      return null;
    };
    return first(item?.subItems);
  }

  /** Label click: on desktop go to the product; below desktop keep the old toggle. */
  openProduct(event: Event, index: number, item: any) {
    if (window.innerWidth < 992 || !this.hasItems(item)) {
      this.onMenuClick(event, index, item);
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const link = this.landingLink(item);
    this.activeButton = item.label;
    this.closeAllMenus();
    if (link) this.router.navigateByUrl(link);
  }

  /** Arrow click: open / close this product's sub-menu. */
  toggleProductMenu(event: Event, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.subIndex = null;
    this.manageOpen = false;
    this.index = this.index === index ? null : index;
  }

  /**
   * Nested menus (e.g. Control Panel > Supplier) open to the right; near the
   * right edge of the screen that runs off-screen. Measure once it is shown and
   * flip it to open on the left side instead.
   */
  keepSubmenuOnScreen(event: Event) {
    const host = event.currentTarget as HTMLElement;
    const menu = host?.querySelector(':scope > .dropdown-menu') as HTMLElement | null;
    if (!menu) return;
    menu.classList.remove('open-left');
    requestAnimationFrame(() => {
      const rect = menu.getBoundingClientRect();
      if (rect.width && rect.right > window.innerWidth - 8) {
        menu.classList.add('open-left');
      }
    });
  }

  onSubMenu(event: any, index) {
    event.stopPropagation();
    this.subIndex = index;
    // click-opened (touch) submenus get the same edge check
    const host = (event.currentTarget as HTMLElement)?.parentElement;
    if (host) setTimeout(() => this.keepSubmenuOnScreen({ currentTarget: host } as unknown as Event));

    const nextEl = event.target.nextElementSibling;

    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
      }
    }
    return false;
  }
  onSubMenuClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const target = event.target;
    // Check if the clicked element is an <a> tag
    const submenuElement = this.subMenu.nativeElement as HTMLElement;

    if (submenuElement) {
      // Toggle 'show' class on the submenu
      submenuElement.classList.toggle('show');
    }
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {
    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById(
                  'topnav-menu-content'
                );
                if (menuelement !== null)
                  if (menuelement.classList.contains('show'))
                    document
                      .getElementById('topnav-menu-content')
                      .classList.remove('show');
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    const elem = this.element || document.documentElement;

    document.body.classList.toggle('fullscreen-enable');

    if (
      !document.fullscreenElement
    ) {
      // Enter fullscreen
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }


  /**
   * Topbar light
   */
  topbarDark() {
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-layout-size');
  }

  /**
   * Set boxed width
   */
  boxedWidth() {
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-topbar', 'colored');
  }

  /**
   * Colored header
   */
  coloredHeader() {
    document.body.setAttribute('data-topbar', 'colored');
    document.body.removeAttribute('data-layout-size');
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Initialize
   */
  initialize(): void {
    let menuList: any[] = MENU.map((item: any) => {
      let filteredObj: any = {};
      let secondArr = [];
      let thirdArr = [];
      Object.keys(this.permissions).forEach((key) => {
        if (key.toLowerCase() === item.label.toLowerCase()) {
          if (item.subItems && !item.link && this.permissions[key].view) {
            let subItemsFiltered = item.subItems.filter((subItem: any) => {
              let subItemPermissionKeys = Object.keys(this.permissions[key]);
              return subItemPermissionKeys.some((permissionKey) => {
                return (
                  permissionKey.toLowerCase() === subItem.label.toLowerCase() &&
                  this.permissions[key][permissionKey].view
                );
              });
            });
            subItemsFiltered.forEach((innerArray) => {
              if (!innerArray.link && innerArray.subItems) {
                if (item.label.toLowerCase() === key.toLowerCase()) {
                  Object.keys(this.permissions[key]).forEach((keys) => {
                    if (
                      keys.toLowerCase() === innerArray?.label.toLowerCase() &&
                      innerArray.subItems &&
                      !innerArray.link
                    ) {
                      secondArr = [];
                      innerArray?.subItems.forEach((secondArray) => {
                        thirdArr = [];
                        Object.keys(this.permissions[key][keys]).forEach(
                          (keyName) => {
                            if (
                              keyName.toLowerCase() ===
                              secondArray?.label.toLowerCase() &&
                              secondArray.subItems &&
                              !secondArray.link &&
                              this.permissions[key][keys][keyName]?.view ===
                              true
                            ) {
                              secondArray?.subItems?.forEach((thirdArray) => {
                                Object.keys(
                                  this.permissions[key][keys][keyName]
                                ).forEach((keyValue) => {
                                  if (
                                    keyValue.toLowerCase() ===
                                    thirdArray?.label.toLowerCase()
                                  ) {
                                    if (
                                      this.permissions[key][keys][keyName][
                                        keyValue
                                      ]?.view === true
                                    ) {
                                      thirdArr.push(thirdArray);
                                    }
                                  }
                                });
                              });

                              secondArray.subItems = thirdArr;
                              secondArr.push(secondArray);
                            } else {
                              if (
                                this.permissions[key][keys][keyName]?.view &&
                                keyName.toLowerCase() ==
                                secondArray?.label.toLowerCase()
                              ) {
                                secondArr.push(secondArray);
                              }
                            }
                          }
                        );
                      });

                      innerArray.subItems = secondArr;
                    }
                  });
                }
              }
            });
            if (subItemsFiltered.length > 0) {
              filteredObj = {
                id: item.id,
                label: item.label,
                link: item.link,
                icon: item.icon,
                subItems: subItemsFiltered,
              };
            }
          } else if (
            !item.subItems &&
            item.link &&
            this.permissions[key].view
          ) {
            filteredObj = item;
          }
        }
      });
      return filteredObj;
    }).filter((filteredItem: any) => Object.keys(filteredItem).length !== 0);

    this.menuItems = menuList;
  }

  // ---- "Manage" group (desktop) ----------------------------------------------------
  // Back-office menus sit behind one "Manage" button (a wide panel with all of
  // them side by side), so the product menus fit on one row. Mobile keeps the
  // full list.
  readonly manageLabels = ['Accounts', 'Operations', 'Control Panel', 'Admin Panel', 'Reports'];
  manageOpen = false;

  isManageItem(item: MenuItem): boolean {
    return this.manageLabels.includes(item?.label);
  }

  get manageItems(): MenuItem[] {
    return (this.menuItems || []).filter((item) => this.isManageItem(item));
  }

  get isManageActive(): boolean {
    return this.manageLabels.includes(this.activeButton);
  }

  toggleManage(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.manageOpen = !this.manageOpen;
    if (this.manageOpen) {
      this.hubQuery = '';
      this.hubResults = [];
      // open on the section the current page belongs to
      const url = this.router.url.split('?')[0];
      const idx = this.hubSections.findIndex((s) => s.links.some((l) => url === l.link || url.startsWith(l.link + '/')));
      this.hubTab = idx > -1 ? idx : 0;
      setTimeout(() => this.hubSearchInput?.nativeElement.focus(), 0);
    }
  }

  closeManage() {
    this.manageOpen = false;
  }

  // a click anywhere outside the panel closes it
  @HostListener('document:click')
  closeManageOnOutsideClick() {
    this.manageOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeManageOnEscape() {
    this.manageOpen = false;
  }

  // ---- Manage panel content ("hub"): tabs per section, pages in a grid -------------
  hubTab = 0;
  hubQuery = '';
  hubResults: HubLink[] = [];
  @ViewChild('hubSearchInput') hubSearchInput?: ElementRef<HTMLInputElement>;
  private hubSource: any[] | null = null;
  private hubCache: HubSection[] = [];

  // shortcuts shown in the panel's top strip, if the user has them
  private readonly hubQuickLabels = ['Invoices', 'Ledger', 'Payment History', 'Agency Master'];

  get hubSections(): HubSection[] {
    if (this.hubSource !== this.menuItems) {
      this.hubCache = this.manageItems.map((section: any) => {
        const links: HubLink[] = [];
        const entries: HubEntry[] = (section.subItems || []).map((sub: any) => {
          if (this.hasItems(sub)) {
            const children: HubLink[] = [];
            for (const leaf of sub.subItems) {
              if (this.hasItems(leaf)) {
                for (const leaf2 of leaf.subItems) {
                  if (leaf2?.link) children.push({ label: `${leaf.label} · ${leaf2.label}`, link: leaf2.link, icon: leaf2.icon, path: `${section.label} › ${sub.label}` });
                }
              } else if (leaf?.link) {
                children.push({ label: leaf.label, link: leaf.link, icon: leaf.icon, path: `${section.label} › ${sub.label}` });
              }
            }
            links.push(...children);
            return { label: sub.label, icon: sub.icon, children };
          }
          const link = { label: sub.label, link: sub.link, icon: sub.icon, path: section.label };
          if (sub?.link) links.push(link);
          return { label: sub.label, icon: sub.icon, link: sub.link, children: [] };
        });
        return {
          label: section.label,
          icon: section.icon,
          subtitle: entries.slice(0, 3).map((e) => e.label).join(', '),
          count: links.length,
          entries,
          links,
        };
      });
      this.hubSource = this.menuItems;
    }
    return this.hubCache;
  }

  /** Every page under Manage (no Array.flatMap: the project's TS lib predates ES2019). */
  private get allHubLinks(): HubLink[] {
    return this.hubSections.reduce((acc: HubLink[], s) => acc.concat(s.links), []);
  }

  get hubQuickLinks(): HubLink[] {
    const all = this.allHubLinks;
    return this.hubQuickLabels
      .map((label) => all.find((l) => l.label.toLowerCase() === label.toLowerCase()))
      .filter(Boolean) as HubLink[];
  }

  onHubSearch(value: string) {
    this.hubQuery = value;
    const words = value.toLowerCase().split(/\s+/).filter(Boolean);
    this.hubResults = !words.length
      ? []
      : this.allHubLinks
          .filter((l) => words.every((w) => `${l.label} ${l.path}`.toLowerCase().includes(w)))
          .slice(0, 24);
  }

  onHubSearchEnter() {
    const first = this.hubResults[0];
    if (first?.link) {
      this.router.navigateByUrl(first.link);
      this.closeManage();
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  setProxyStatus(event: any) {
    this.profileIcon = false;
    const data = {
      status: event?.checked,
    };
    this.flightService.changeProxyStatus(data).subscribe({
      next: (response: any) => {
        this.tostrService.success(
          'Proxy status changed successfully',
          'Success'
        );
      },
      error: (error: any) => {
        this.tostrService.error('Unable to change proxy status', 'Error');
      },
    });
  }

  getProxyStatus() {
    this.flightService.getProxyStatus().subscribe({
      next: (response: any) => {
        this.isProxy = response?.data?.proxy_status;
        this.userRole = this.storageService.getLocalStorageItem('role_name');
      },
    });
  }

  transformLabel(label: string): string {
    return label?.replace(/_/g, '-') || '';
  }

  getColor() {
    return { color: this.avalBal > 0 ? 'green' : 'red' };
  }
}
